// src/campaigns/constants/campaign-archetypes.ts

import { ArchetypeId } from "../../constants/archetypes";
import { CampaignTheme } from "../types/campaign.types";

export const CAMPAIGN_ARCHETYPE_THEMES: Record<ArchetypeId, CampaignTheme> = {
  moments: {
    primary: "#f9ca24",
    secondary: "#f6e58d",
    accent: "#f0932b",
    background: "#120f02",
    glow: "rgba(249,202,36,0.42)",
  },
  heartbeat: {
    primary: "#ff4d6d",
    secondary: "#ff8fa3",
    accent: "#ffb3c6",
    background: "#160609",
    glow: "rgba(255,77,109,0.42)",
  },
  safehaven: {
    primary: "#a5b1c2",
    secondary: "#778ca3",
    accent: "#4b6584",
    background: "#060a10",
    glow: "rgba(165,177,194,0.38)",
  },
};

export const CAMPAIGN_ARCHETYPE_LABELS: Record<ArchetypeId, string> = {
  heartbeat: "Heartbeat",
  moments: "Moments",
  safehaven: "Safe Haven",
};

export const DEFAULT_CAMPAIGN_ARCHETYPE: ArchetypeId = "heartbeat";
